import { StageApiResponse, StageApiSensor } from "../jefdaqLegacyApi/stage";

import { isLengthUnit } from "../convert";
import { ISample_, IStageData_, StreamSensor_ } from "../models/StreamSensor";
import notEmpty from "../shared/notEmpty";
import { streamPeriods, streamPeriodSeconds } from "../shared/streamPeriods";


export const stageApiToSensors = (
  stageApiResponse: StageApiResponse
): StreamSensor_[] => {
  const apiIntervals = stageApiResponse.meta.periodsSeconds;
  if (JSON.stringify(apiIntervals) !== JSON.stringify(streamPeriodSeconds)) {
    throw new Error("Stage periods do not match");
  }

  const apiSensorToStreamSensor = (
    apiSensor: StageApiSensor
  ): StreamSensor_ | undefined => {
    const type = "stream";
    const { site, name, source, lastReport, latitude, longitude, unitShort, stages, times } = apiSensor;

    const unit = unitShort.toLowerCase().trim();
    if (!isLengthUnit(unit)) {
      console.error("No compatible unit for stage sensor " + site);
      return undefined;
    }

    if (!lastReport || apiSensor.stage === null) {
      return undefined;
    }
    const latest: ISample_ = { time: lastReport, value: apiSensor.stage };
    const max: { [period: string]: ISample_ } = {}
    for (let i = 0; i < streamPeriods.length; i++) {
      const time = times[i];
      const value = stages[i];
      if (time && value) {
        const period = streamPeriods[i];
        max[period] = { time, value };
      }
    }

    const stage: IStageData_ = { unit, latest, max };

    const sensor: StreamSensor_ = {
      ...stageApiResponse.meta,
      type,
      id: site,   // not a typo, inconsistent
      site: name, // naming with legacy API
      latitude,
      longitude,
      latest: lastReport || undefined,
      stage,
      discharge: undefined,
      owner: source
    };

    return sensor;
  };

  return stageApiResponse.data.map(apiSensorToStreamSensor).filter(notEmpty);
};
